/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from "axios";
import QS from "qs";
// import router from "@/router";
import { getToken } from "@/utils/auth";

function initParams(params) {
  if (params) {
    if (Object.keys(params).length > 0) {
      Object.keys(params).forEach((keyName) => {
        if (
          params[keyName] &&
          params[keyName] != "" &&
          typeof params[keyName] == "string"
        ) {
          params[keyName] = params[keyName].replace(
            new RegExp("'", "g"),
            "\\\\'"
          );
        }
      });
    }
    return params;
  } else {
    return {};
  }
}

const axiosinstance = axios.create({
  withCredentials: true,
});
// 请求超时时间
axiosinstance.defaults.timeout = 100000;
// 携带cookie
axiosinstance.defaults.withCredentials = true;
// post请求头
axiosinstance.defaults.headers.post["Content-Type"] =
  "application/json;charset=utf-8";
// 请求拦截器
axiosinstance.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const getTokenStr = getToken();

    config.headers = {
      "Content-Type": "application/json;charset=utf-8",
    };
    if (getTokenStr) {
      config.headers["Authorization"] = "Bearer " + getTokenStr; // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

// 响应拦截器
axiosinstance.interceptors.response.use(
  (response) => {
 console.log('111',response)
    if (response.status === 200) {
      if (response.data.code === 401) {
        // router.push("/login");
        return Promise.reject(response);
      }
      return Promise.resolve(response);
    } else if (response.status === 302) {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.data && error.data.code) {
      switch (error.data.code) {
        case 404:
          console.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        case 401:
          break;
        // 其他错误，直接抛出错误提示
        default:
        // console.error(error.data.message);
      }
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axiosinstance
      .get(url, {
        params: initParams(params),
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export function getHandle(url) {
  return new Promise((resolve, reject) => {
    axiosinstance
      .request({
        url,
        method: "GET",
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axiosinstance
      .post(url, QS.stringify(initParams(params)))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
export function postHadle(url, params) {
  return new Promise((resolve, reject) => {
    axiosinstance
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
